export default "__VITE_ASSET__BhfUnqpV__"